export const DEFAULT_MCP_ROUTER_REFERER = 'https://mcp.pcnaid.com';
export const DEFAULT_MCP_ROUTER_TITLE = 'Pcnaid AI Hub';
export const DEFAULT_MCP_ROUTER_BASE_URL = 'https://api.mcprouter.to/v1';
